var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_1034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.72 45.4901L43.88 57.3301V24.1401C43.88 23.3101 43.21 22.6401 42.38 22.6401C41.55 22.6401 40.88 23.3101 40.88 24.1401V57.1001L29.28 45.5001C28.69 44.9101 27.74 44.9101 27.16 45.5001C26.57 46.0901 26.57 47.0401 27.16 47.6201L41.01 61.4701C41.24 62.0001 41.77 62.3601 42.38 62.3601C42.58 62.3601 42.77 62.3201 42.94 62.2501C43.17 62.1801 43.38 62.0801 43.56 61.9001L57.85 47.6201C58.44 47.0301 58.44 46.0801 57.85 45.5001C57.26 44.9201 56.31 44.9101 55.73 45.5001L55.72 45.4901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 0C19.07 0 0 19.07 0 42.5C0 65.93 19.07 85 42.5 85C65.93 85 85 65.93 85 42.5C85 19.07 65.93 0 42.5 0ZM42.5 82C20.72 82 3 64.28 3 42.5C3 20.72 20.72 3 42.5 3C64.28 3 82 20.72 82 42.5C82 64.28 64.28 82 42.5 82Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_1034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.3cf1cccf588cebc22020744ccaca1def.svg";
export { ForwardRef as ReactComponent };